import Component from './AuthenticatorCode.component';
import { connect } from 'react-redux';
import { getId } from '/b2b/authentication/state/user/AuthUser.selectors';
import { onCopy } from './AuthenticatorCode.commands';

const mapStateToProps = state => {
    return {
        userId: getId(state),
    };
};

const mapDispatchToProps = { onCopy };

export default connect(mapStateToProps, mapDispatchToProps)(Component);
